import styled from 'styled-components';
import Color from 'octa-front-sdk/dist/enums/Color';
import FontSize from 'octa-front-sdk/dist/enums/FontSize';

interface CategoriesListInputFilter {
  showInput: boolean;
}

const FilterTitle = styled.p`
  font-size: ${FontSize.Normal};
  text-align: center;
  margin: 0;
  padding: 20px;
  background-color: ${Color.Grey200};
`;

const Category = styled.li`
  white-space: nowrap;
  padding: 5px 20px;
  color: ${Color.Grey900};
  border: 1px solid ${Color.Grey900};
  border-radius: 50px;
  margin-left: 20px;
  cursor: pointer;

  &.active {
    color: ${Color.White};
    border: none;
    background-color: ${Color.Grey900};
  }

  @media (min-width: 1280px) {
    padding: 0;
    margin: 0 0 20px;
    border: none;
    border-radius: initial;
    color: ${Color.Grey700};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.active {
      background-color: initial;
      font-weight: bold;
      color: initial;
    }
  }
`;

const CategoriesList = styled.ul`
  display: flex;
  margin: 0;
  padding: 20px 0;
  list-style: none;
  overflow-x: auto;
  box-sizing: content-box;

  &::after {
    content: '';
    flex: 0 0 20px;
  }

  @media (min-width: 1280px) {
    flex-direction: column;
    padding: 20px;
  }
`;

const CategoriesListWrapper = styled.div`
  @media (min-width: 1280px) {
    flex: 1;
    overflow: auto;
  }
`;

const CategoriesListInputFilter = styled.li<CategoriesListInputFilter>`
  margin-left: 20px;
  display: flex;
  align-items: center;

  button {
    margin-right: ${(props): string => (props.showInput ? '10px' : '0')};
  }

  > div > button {
    opacity: ${(props): string => (props.showInput ? '1' : '0')};
    width: ${(props): string => (props.showInput ? 'auto' : '0')};
    padding: ${(props): string => (props.showInput ? '1' : '0')};
  }

  > div > div > input {
    width: ${(props): string => (props.showInput ? '15rem' : '0')};
    opacity: ${(props): string => (props.showInput ? '1' : '0')};
    padding: ${(props): string => (props.showInput ? '1' : '0')};
    height: 30px;
    margin-bottom: 0;
  }

  @media (min-width: 1280px) {
    flex: 1;
    margin-left: 0;
    margin-bottom: 10px;
    overflow: auto;

    button {
      display: none;
    }

    > div > div > input {
      width: 100%;
      height: auto;
      opacity: initial;
      padding: 10px 15px;
    }
  }
`;

const Content = styled.div<{ isFixed: boolean }>`
  width: 100%;
  position: ${({ isFixed }): string => (isFixed ? 'fixed' : 'absolute')};
  top: 0;
  left: 0;
  box-sizing: border-box;
  background-color: ${Color.BlueGrey50};
  z-index: ${({ isFixed }): string => (isFixed ? '99' : 'initial')};

  @media (min-width: 1280px) {
    display: flex;
    flex-direction: column;
    width: auto;
    max-width: calc((100vw - 800px) / 2 - 20px);
    max-height: calc(100vh - 100px);
    background-color: ${Color.White};
    border: 1px solid ${Color.Grey200};
    border-radius: 20px;
    top: 80px;
    left: 20px;
    overflow: hidden;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.16),
      0px -1px 5px -5px rgba(0, 0, 0, 0.16);
  }
`;

const Container = styled.div`
  position: relative;
  margin-top: 20px;
  height: 70px;

  @media (min-width: 1280px) {
    margin-top: initial;
    height: initial;
  }
`;

const CategoriesFilterStyles = {
  FilterTitle,
  Category,
  CategoriesList,
  CategoriesListWrapper,
  CategoriesListInputFilter,
  Content,
  Container,
};

export default CategoriesFilterStyles;
